import VetQuestApi from "./VetQuestApi";
import { ResponseModel, IStateModel } from "@/models";

export abstract class StateService {
  static BASE: string = "state";
  static async GetAllAsync(): Promise<ResponseModel<IStateModel[]>> {
    let response = new ResponseModel<IStateModel[]>(0, [] as IStateModel[]);
    try {
      const { data, status } = await VetQuestApi().get(`${this.BASE}`);
      if (status === 200) {
        response.status = 200;
        response.data = data;
      }
    } catch (err) {
      response.status = err.response.status;
      response.error = err.response;
    }
    return response;
  }
}
